// Copyright (c) 2025 Nebularis Holdings LLC
// Licensed to Nutrx Solutions under a non-exclusive, non-transferable license.
// See IP License Agreement for usage restrictions.

// frontend/src/components/execution-plans/RollbackPlanCard.jsx

import React from "react";
import { ExecutionPlanSection, EmptyPanel, bodyTextStyle, displayValue } from "./ExecutionSummaryCard";

export default function RollbackPlanCard({ rollbackPlan }) {
  const steps = Array.isArray(rollbackPlan?.steps) ? rollbackPlan.steps : [];

  if (!rollbackPlan) {
    return <EmptyPanel title="No rollback plan" message="Rollback guidance has not been generated for this task yet." />;
  }

  return (
    <ExecutionPlanSection eyebrow="Rollback" title="Rollback plan" badge={rollbackPlan?.available ? "available" : "review"}>
      <p style={bodyTextStyle}>{displayValue(rollbackPlan?.summary, "Rollback is operator-controlled and advisory only.")}</p>
      {steps.length ? (
        <ol style={{ color: "#bfdbfe", fontSize: 13, lineHeight: 1.55, margin: "14px 0 0", paddingLeft: 18 }}>
          {steps.map((step, index) => <li key={`rollback-${index}`}>{displayValue(step)}</li>)}
        </ol>
      ) : null}
      <div style={{ marginTop: 14, border: "1px solid rgba(251, 191, 36, 0.22)", borderRadius: 14, padding: 12, background: "rgba(120, 53, 15, 0.16)" }}>
        <strong style={{ color: "#fde68a", display: "block", marginBottom: 4 }}>Guardrail</strong>
        <p style={bodyTextStyle}>{displayValue(rollbackPlan?.guardrail, "No rollback is executed automatically.")}</p>
      </div>
    </ExecutionPlanSection>
  );
}
